"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LabelWrapperCol = void 0;

var _context = require("../../context");

var _layout = require("../../layout");

var _utils = require("../../utils");

var LabelWrapperCol = (0, _context.styledWithTheme)(_layout.Col)(function (_ref) {
  var theme = _ref.theme;
  return {
    alignItems: 'flex-start',
    gap: (0, _utils.getThemeSpace)(theme, _utils.LABEL_SPACING)
  };
});
exports.LabelWrapperCol = LabelWrapperCol;